import { Chart, registerables } from 'chart.js';

Chart.register(...registerables);

// Guard: prevent Chart.js draw cycle when canvas context is lost (e.g. after
// destroy/re-render race). A plugin-based guard doesn't work because Chart.js
// disables the plugin system after destroy() (sets _plugins._init = undefined),
// so notifyPlugins returns undefined instead of false and the draw proceeds.
// Monkey-patching draw() directly is the only reliable guard.
const _origDraw = Chart.prototype.draw;
Chart.prototype.draw = function () {
  if (!this.ctx) return;
  return _origDraw.apply(this, arguments);
};

export function gewichtChart(entries) {
  return {
    _chart: null,
    _observer: null,
    entries,

    init() {
      this.$nextTick(() => this.render());
      this._observer = new MutationObserver(() => this.retheme());
      this._observer.observe(document.documentElement, {
        attributes: true,
        attributeFilter: ['class'],
      });
    },

    destroy() {
      this._observer?.disconnect();
      this._chart?.destroy();
    },

    theme() {
      const dark = document.documentElement.classList.contains('dark');
      return {
        text: dark ? '#9ca3af' : '#6b7280',
        grid: dark ? 'rgba(255,255,255,0.08)' : 'rgba(0,0,0,0.06)',
        line: dark ? '#a78bfa' : '#7c3aed',
        fill: dark ? 'rgba(167,139,250,0.10)' : 'rgba(124,58,237,0.08)',
        point: dark ? '#c4b5fd' : '#6d28d9',
        tooltipBg: dark ? '#1f2937' : '#111827',
      };
    },

    render() {
      this._chart?.destroy();
      this._chart = null;

      const canvas = this.$refs.chart;
      if (!canvas) return;

      const t = this.theme();
      const labels = this.entries.map((e) => e.datum);
      const data = this.entries.map((e) => parseFloat(e.waarde));

      this._chart = new Chart(canvas, {
        type: 'line',
        data: {
          labels,
          datasets: [
            {
              label: 'Gewicht (kg)',
              data,
              borderColor: t.line,
              backgroundColor: t.fill,
              pointBackgroundColor: t.point,
              pointRadius: data.length > 90 ? 0 : 2,
              pointHoverRadius: 4,
              borderWidth: 2,
              fill: true,
              tension: 0.3,
            },
          ],
        },
        options: {
          responsive: true,
          maintainAspectRatio: false,
          interaction: { mode: 'index', intersect: false },
          plugins: {
            legend: { display: false },
            tooltip: {
              backgroundColor: t.tooltipBg,
              padding: 10,
              cornerRadius: 6,
              callbacks: {
                label: (ctx) => `${ctx.parsed.y.toFixed(1)} kg`,
              },
            },
          },
          scales: {
            x: {
              ticks: {
                color: t.text,
                maxTicksLimit: 12,
                callback: function (val, idx) {
                  const d = this.getLabelForValue(val);
                  // Show as "jan", "feb", etc.
                  const dt = new Date(d + 'T00:00:00');
                  return dt.toLocaleDateString('nl-BE', { day: 'numeric', month: 'short' });
                },
              },
              grid: { display: false },
            },
            y: {
              ticks: {
                color: t.text,
                callback: (v) => v.toFixed(1) + ' kg',
              },
              grid: { color: t.grid },
            },
          },
        },
      });
    },

    retheme() {
      this.render();
    },
  };
}
